import React, { useEffect, useState } from 'react';
import { AdminShell } from '@/components/layout/AdminShell';
import { Card } from '@/components/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Markdown } from '@/components/Markdown';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { Save, Eye } from 'lucide-react';

const SLUGS = [
    { slug: 'refund', label: 'Refund Policy' },
    { slug: 'privacy', label: 'Privacy Policy' },
    { slug: 'fair-use', label: 'Fair Use Policy' },
    { slug: 'terms', label: 'Terms of Service' },
];

export default function AdminPoliciesPage() {
    const [policies, setPolicies] = useState({});
    const [active, setActive] = useState('refund');

    const load = async () => {
        const { data } = await api.get('/policies');
        const map = {};
        for (const p of data.policies) map[p.slug] = p;
        setPolicies(map);
    };
    useEffect(() => { load(); }, []);

    const save = async (slug) => {
        try { await api.put(`/policies/${slug}`, { content: policies[slug].content, title: policies[slug].title }); toast.success('Policy saved'); load(); }
        catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); }
    };
    const set = (slug, key, val) => setPolicies(prev => ({ ...prev, [slug]: { ...(prev[slug] || {}), [key]: val } }));

    return (
        <AdminShell title="Policies">
            <Tabs value={active} onValueChange={setActive}>
                <TabsList>
                    {SLUGS.map(s => <TabsTrigger key={s.slug} value={s.slug} data-testid={`admin-policy-tab-${s.slug}`}>{s.label}</TabsTrigger>)}
                </TabsList>
                {SLUGS.map(s => {
                    const p = policies[s.slug] || { title: s.label, content: '' };
                    return (
                        <TabsContent key={s.slug} value={s.slug} className="mt-4">
                            <Card className="p-4 sm:p-5">
                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                    <div>
                                        <div className="space-y-2 mb-3"><Label>Title</Label><Input value={p.title || ''} onChange={e => set(s.slug, 'title', e.target.value)} /></div>
                                        <div className="space-y-2"><Label>Content (Markdown)</Label><Textarea rows={20} className="font-mono text-xs" value={p.content || ''} onChange={e => set(s.slug, 'content', e.target.value)} data-testid={`admin-policy-textarea-${s.slug}`} /></div>
                                        <Button onClick={() => save(s.slug)} className="mt-3 bg-[#0E2A47]" data-testid={`admin-policy-save-${s.slug}`}><Save className="h-4 w-4 mr-1" /> Save</Button>
                                    </div>
                                    <div>
                                        <div className="text-xs uppercase tracking-wider text-muted-foreground mb-2 flex items-center gap-1"><Eye className="h-3.5 w-3.5" /> Live preview</div>
                                        <div className="border border-border rounded-xl p-4 bg-white max-h-[60vh] overflow-y-auto">
                                            <h1 className="font-display text-2xl font-semibold mb-2">{p.title}</h1>
                                            <Markdown content={p.content || ''} />
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </TabsContent>
                    );
                })}
            </Tabs>
        </AdminShell>
    );
}
